module.exports = __webpack_public_path__ + "img/172.5568ee90.jpg";